import React, { useState, useEffect, useRef } from "react";
import { Outlet, Link } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from "react-router-dom";

const Navbar = ({ group }) => {
  const { user, authStatus, signOut } = useAuthenticator((context) => [
    context.user,
    context.authStatus,
  ]);
  const [color, setColor] = useState("#0c3678");
  const [textcolor, setTextColor] = useState("white");
  const [navimg, setNavImg] = useState(require('../img/logo_uh_red.png'));
  const [textShadow, setTextShadow] = useState('none');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isWorkflowDropdownOpen, setIsWorkflowDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const workflowDropdownRef = useRef(null);

  const userEmail = user?.attributes?.email;

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeColor, { passive: true });
    return function cleanup() {
      window.removeEventListener("scroll", changeColor);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (workflowDropdownRef.current && !workflowDropdownRef.current.contains(event.target)) {
        setIsWorkflowDropdownOpen(false);
      }
    };

    if (isDropdownOpen || isWorkflowDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen, isWorkflowDropdownOpen]);

  const changeColor = () => {
    if (
      document.documentElement.scrollTop > 50 ||
      document.body.scrollTop > 50
    ) {
      setColor("white");
      setTextColor("#161616");
      setNavImg(require('../img/logo_uh_secondary.png'));
      setTextShadow('none');
    } else if (
      document.documentElement.scrollTop < 49 ||
      document.body.scrollTop < 49
    ) {
      setColor("#0c3678");
      setTextColor("white");
      setNavImg(require('../img/logo_uh_red.png'));
    }
  };

  const navigate = useNavigate();
  function handleSignOut() {
    signOut();
    setIsDropdownOpen(false); // Close the dropdown when signing out
    navigate('/');
  }

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleWorkflowDropdown = () => {
    setIsWorkflowDropdownOpen(!isWorkflowDropdownOpen);
  };

  return (
    <div>
      <style>{`
        .workflow-button {
          display: block;
          padding: 8px 12px;
          margin: 5px 0;
          background-color: #f0f0f0;
          color: black;
          border: 1px solid #ccc;
          border-radius: 4px;
          text-decoration: none;
          text-align: center;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease-in-out;
        }

        .workflow-button:hover {
          background-color: #e0e0e0;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
      `}</style>
      <nav className="nav" style={{ backgroundColor: color, color: textcolor, textShadow: textShadow }}>
        <div>
          <a href="/">
            <img
              src={navimg}
              alt="UH-logo"
              title=""
              style={{
                margin: '5px',
                height: "60px",
                display: "inline-flex",
                verticalAlign: "middle"
              }}
            />
          </a>
        </div>
        <ul>
          <li>
            <Link to="/" style={{ fontSize: '1.1em' }}>Home</Link>
          </li>
          <li>
            <Link to="/About" style={{ fontSize: '1.1em' }}>About</Link>
          </li>
          {(authStatus !== 'authenticated') ? (
            <li>
              <Link to="/Login" style={{ fontSize: '1.1em' }}>Login</Link>
            </li>
          ) : (
            <>
              <li>
                <Link to='/HowTo' style={{ fontSize: '1.1em' }}>How To</Link>
              </li>

              <li style={{ position: 'relative' }} ref={workflowDropdownRef}>
                <button onClick={toggleWorkflowDropdown} className="navButton" style={{ textShadow: textShadow, fontSize: '1.1em' }}>
                  Workflow
                </button>
                {isWorkflowDropdownOpen && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '10px',
                    zIndex: 1000,
                    color: 'black',
                    minWidth: '220px'
                  }}>
                    <Link to="/LeadsheetUpload" className="workflow-button" onClick={() => setIsWorkflowDropdownOpen(false)}>1. Leadsheet Upload</Link>
                    <Link to="/WebScraping" className="workflow-button" onClick={() => setIsWorkflowDropdownOpen(false)}>2. Web Scraping</Link>
                    <Link to="/NetworkGeneration" className="workflow-button" onClick={() => setIsWorkflowDropdownOpen(false)}>3. Network Generation</Link>
                    <Link to="/Networks" className="workflow-button" onClick={() => setIsWorkflowDropdownOpen(false)}>4. Network Visualization</Link>
                  </div>
                )}
              </li>
              <li>
                <Link to="/JobsDashboard" style={{ fontSize: '1.1em' }}>Job Dashboard</Link>
              </li>
              <li style={{ position: 'relative' }} ref={dropdownRef}>
                <button onClick={toggleDropdown} className="navButton" style={{ textShadow: textShadow, display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', padding: '0 10px' }}>
                    <span style={{ fontSize: '0.9em', lineHeight: '1.2', color: textcolor }}>{userEmail}</span>
                    <span style={{ fontSize: '0.8em', lineHeight: '1.2', color: textcolor }}>Role: {capitalizeFirstLetter(group)}</span>
                  </div>
                </button>
                {isDropdownOpen && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '10px',
                    zIndex: 1000,
                    color: 'black',
                    minWidth: '150px'
                  }}>
                    <button onClick={() => { navigate('/Selector'); setIsDropdownOpen(false); }} style={{
                      width: '100%',
                      padding: '5px 12px',
                      backgroundColor: color,
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      margin: '5px auto'
                    }}>
                      Switch Role
                    </button>
                    <button className="navButton" onClick={handleSignOut} style={{
                      width: '100%',
                      padding: '5px 12px',
                      backgroundColor: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      margin: '0 auto 5px auto'
                    }}>Sign Out</button>
                  </div>
                )}
              </li>
            </>
          )}
        </ul>
      </nav>

      <Outlet />
    </div>
  )
};

export default Navbar;